/**
 * 函数节流
 */
export function throttle (this: any, fn: any, delay: number) {
  let lastTime: number
  let timer: any = null
  // eslint-disable-next-line no-magic-numbers
  delay = delay || 200
  // eslint-disable-next-line prefer-rest-params
  const args: IArguments | null = arguments
  return () => {
    const nowTime = Date.now()
    if (lastTime && nowTime - lastTime < delay) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        lastTime = nowTime
        fn.apply(this, args)
      }, delay)
    } else {
      lastTime = nowTime
      fn.apply(this, args)
    }
  }
}
